<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-dialog-scrollable-general">
          <div class="modal-header">
            <div class="header-title">
              <h4 class="m-0 title-modal">Detalhe da Ordem</h4>
              <div class="ml-3 chip">
                <p class="m-0 order-type">
                  {{
                    rType == "0"
                      ? "Recebimento de dinheiro"
                      : "Envio de dinheiro"
                  }}
                </p>
              </div>
            </div>
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>
          <ng-container *ngIf="rType == '0'">
            <div class="modal-body">
              <div class="p-3 pv-5">
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Número:&nbsp;
                      <span class="value"
                        >{{ this.boobleModalData?.id }}
                      </span></span
                    ><br /><br />
                    <span class="p-text-grey"
                      >Moeda: &nbsp;
                      <span class="value">
                        <mat-icon [svgIcon]="this.currency?.icon"></mat-icon
                        ><span class="ml-2">{{
                          this.currency?.description
                        }}</span>
                      </span></span
                    ><br /><br />
                    <span class="p-text-grey">
                      Valor a receber:&nbsp;
                      <span class="value"
                        >{{ this.boobleModalData?.currency?.description }}
                        {{ this.boobleModalData?.amount | amountPipe }}</span
                      ></span
                    ><br /><br />
                  </div>

                  <div class="col-md-6">
                    <span class="p-text-grey"
                      >Data de criação: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.createdDate | date : "dd/MM/yyyy"
                      }}</span></span
                    ><br /><br />
                    <span class="p-text-grey"
                      >Status: &nbsp;
                      <span
                        *ngIf="this.boobleModalData?.statusFlow == 'PROCESSING'"
                        class="value"
                      >
                        Em análise
                      </span>
                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'AVAILABLE_QUOTATION'
                        "
                        class="value"
                      >
                        Aguardando cotação
                      </span>

                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'IDENTIFYING_PAYMENT_ABROAD'
                        "
                        class="value"
                      >
                        Aguardando pagamento no exterior
                      </span>

                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                            'IDENTIFIED_PAYMENT_ABROAD' ||
                          this.boobleModalData?.statusFlow ==
                            'PENDING_ORDER_INFORMATION'
                        "
                        class="value"
                      >
                        Pendente informações
                      </span>
                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'REPROVED_WITH_CORRECTION'
                        "
                        class="value"
                      >
                        Reprovada
                      </span>
                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                            'AVAILABLE_PAYMENT' &&
                          this.boobleModalData?.remmitanceType == 'INBOUND'
                        "
                        class="value"
                      >
                        Fechamento concluído
                      </span>
                      <span
                        *ngIf="this.boobleModalData?.statusFlow == 'CANCELED'"
                        class="value"
                      >
                        Cancelada
                      </span>

                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'PENDING_LIQUIDATION'
                        "
                        class="value"
                      >
                        Fechamento concluído
                      </span>

                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'IDENTIFYING_PAYMENT'
                          && this.boobleModalData?.remmitanceType == 'OUTBOUND'
                        "
                        class="value"
                      >
                        Aguardando efetivação
                      </span>

                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'IDENTIFYING_PAYMENT'
                          && this.boobleModalData?.remmitanceType == 'INBOUND'
                        "
                        class="value"
                      >
                      Identificando pagamento
                      </span>

                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'IDENTIFIED_PAYMENT'
                        "
                        class="value"
                      >
                        Pagamento identificado
                      </span>

                      <span
                        *ngIf="this.boobleModalData?.statusFlow == 'PAID'"
                        class="value"
                      >
                        Liquidada
                      </span> </span
                    ><br /><br />

                    <span
                      *ngIf="this.boobleModalData?.statusFlow == 'PROCESSING'"
                      class="p-text-grey"
                    >
                      Finalidade:&nbsp;
                      <span class="value"
                        >{{ this.boobleModalData?.finality?.description }}
                      </span></span
                    ><br /><br />
                  </div>
                </div>
                <h4 class="mg-bottom-32 mg-top-8">Dados do pagador</h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Nome:&nbsp;
                      <span class="value"
                        >{{ this.boobleModalData?.sender?.companyName }}
                      </span></span
                    ><br /><br />
                    <span
                      *ngIf="this.boobleModalData?.sender?.email != ''"
                      class="p-text-grey"
                      >E-mail: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.sender?.email
                      }}</span></span
                    ><br /><br />
                  </div>
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      País:&nbsp;
                      <span class="value"
                        >{{
                          this.boobleModalData?.sender?.country?.description
                        }}
                      </span></span
                    ><br /><br />
                  </div>
                </div>

                <ng-container *ngIf="this.boobleModalData?.quotations[0]">
                  <h4 class="mg-bottom-32 mg-top-8">
                    Dados do fechamento de câmbio
                  </h4>
                  <div class="row">
                    <div class="col-md-6">
                      <span class="p-text-grey">
                        Câmbio com spread:&nbsp;
                        <span class="value"
                          >R${{
                            commercial?.toString().replace(".", ",")
                          }}</span
                        ></span
                      ><br /><br />
                      <span class="p-text-grey"
                        >Tarifa: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.quotations[0]?.tariff | brl
                        }}</span></span
                      ><br /><br />
                      <span class="p-text-grey"
                        >Valor em reais: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.quotations[0]?.amountMN | brl
                        }}</span></span
                      ><br /><br />
                    </div>
                    <div class="col-md-6">
                      <ng-container *ngIf="boobleModalData?.quotations[0]?.id">
                        <span class="p-text-grey">
                          Câmbio comercial:&nbsp;
                          <span class="value"
                            >R${{
                              this.boobleModalData?.quotations[0]?.rate
                                ?.toString()
                                .replace(".", ",")
                            }}</span
                          ></span
                        ><br /><br />
                        <span class="p-text-grey"
                          >IOF ({{ iof * 100 | number : "1.2-2" }}%): &nbsp;
                          <span class="value">{{
                            commercial * this.boobleModalData?.amount * iof
                              | brl
                          }}</span></span
                        ><br /><br />
                        <span class="p-text-grey">
                          Imposto de renda ({{ ir * 100 | number : "1.2-2" }}%):
                          &nbsp;
                          <span class="value">{{
                            getIr(
                              this.boobleModalData?.quotations[0]?.rate,
                              this.boobleModalData?.quotations[0]?.spread,
                              ir,
                              this.boobleModalData?.quotations[0]?.ptax
                            ) | brl
                          }}</span></span
                        ><br /><br />
                        <span class="p-text-grey">
                          Valor efetivo total: &nbsp;
                          <span class="value"
                            >{{
                              1
                                | currency
                                  : this.boobleModalData?.currency?.description
                            }}
                            =
                            {{
                              this.boobleModalData?.quotations[0]?.vet | brl
                            }}</span
                          ></span
                        ><br /><br />
                      </ng-container>
                    </div>
                  </div>
                  <h4 class="mg-bottom-32 mg-top-8">Conta para recebimento</h4>
                  <div class="row">
                    <div class="col-md-6">
                      <span class="p-text-grey">
                        Banco:&nbsp;
                        <span class="value"
                          >{{
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.name
                          }}
                        </span></span
                      ><br /><br />
                      <span class="p-text-grey"
                        >Conta com digíto: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount
                            ?.number
                        }}</span></span
                      ><br /><br />
                    </div>
                    <div class="col-md-6">
                      <span class="p-text-grey">
                        Agência:&nbsp;
                        <span class="value"
                          >{{
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.agency
                          }}
                        </span></span
                      ><br /><br />
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="this.boobleModalData?.reprovedMsg">
                  <h4>Motivo da reprovação</h4>
                  <div class="row">
                    <div class="reason">
                      <span>
                        {{ this.boobleModalData?.reprovedMsg }}
                      </span>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="this.boobleModalData?.canceledMsg">
                  <h4>Motivo do cancelamento</h4>
                  <div class="row">
                    <div class="reason">
                      <span>
                        {{ this.boobleModalData?.canceledMsg }}
                      </span>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="rType == '1'">
            <div class="modal-body">
              <div class="p-3 pv-5">
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Número:&nbsp;
                      <span class="value"
                        >{{ this.boobleModalData?.id }}
                      </span></span
                    ><br /><br />
                    <span class="p-text-grey"
                      >Moeda: &nbsp;
                      <span class="value">
                        <mat-icon [svgIcon]="this.currency?.icon"></mat-icon
                        ><span class="ml-2">{{
                          this.currency?.description
                        }}</span>
                      </span></span
                    ><br /><br />
                    <span class="p-text-grey">
                      Valor de destino:&nbsp;
                      <span class="value"
                        >{{ this.boobleModalData?.currency?.description }}
                        {{ this.boobleModalData?.amount | amountPipe }}</span
                      ></span
                    ><br /><br />
                  </div>

                  <div class="col-md-6">
                    <span class="p-text-grey"
                      >Data de criação: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.createdDate | date : "dd/MM/yyyy"
                      }}</span></span
                    ><br /><br />
                    <span class="p-text-grey"
                      >Status: &nbsp;
                      <span
                        *ngIf="this.boobleModalData?.statusFlow == 'PROCESSING'"
                        class="value"
                      >
                        Em análise
                      </span>

                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'AVAILABLE_QUOTATION'
                        "
                        class="value"
                      >
                        Aguardando cotação
                      </span>
                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'REPROVED_WITH_CORRECTION'
                        "
                        class="value"
                      >
                        Reprovada
                      </span>
                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                            'AVAILABLE_PAYMENT' &&
                          this.boobleModalData?.remmitanceType == 'OUTBOUND'
                        "
                        class="value"
                      >
                        Aguardando efetivação
                      </span>
                      <span
                        *ngIf="this.boobleModalData?.statusFlow == 'CANCELED'"
                        class="value"
                      >
                        Cancelada
                      </span>

                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'PENDING_LIQUIDATION'
                        "
                        class="value"
                      >
                        Fechamento concluído
                      </span>

                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'PENDING_INVOICE_ATTACHMENT'
                        "
                        class="value"
                      >
                        Ordem criada
                      </span>

                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'IDENTIFYING_PAYMENT'
                          && this.boobleModalData?.remmitanceType == 'OUTBOUND'
                        "
                        class="value"
                      >
                        Aguardando efetivação
                      </span>

                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'IDENTIFYING_PAYMENT'
                          && this.boobleModalData?.remmitanceType == 'INBOUND'
                        "
                        class="value"
                      >
                        Identificando pagamento
                      </span>

                      <span
                        *ngIf="
                          this.boobleModalData?.statusFlow ==
                          'IDENTIFIED_PAYMENT'
                        "
                        class="value"
                      >
                        Pagamento identificado
                      </span>

                      <span
                        *ngIf="this.boobleModalData?.statusFlow == 'PAID'"
                        class="value"
                      >
                        Liquidada
                      </span> </span
                    ><br /><br />

                    <span class="p-text-grey">
                      Finalidade:&nbsp;
                      <span class="value"
                        >{{ this.boobleModalData?.finality?.description }}
                      </span></span
                    ><br /><br />
                  </div>
                  <div class="col-md-12">
                    <span class="p-text-grey">
                      Observação:&nbsp;
                      <span class="value"
                        >{{ this.boobleModalData?.observation }}
                      </span></span
                    ><br /><br />
                  </div>
                </div>

                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados do recebedor
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Nome:&nbsp;
                      <span class="value"
                        >{{ this.boobleModalData?.receiver?.name }}
                      </span></span
                    ><br /><br />
                    <span class="p-text-grey"
                      >Banco: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount?.bank ||
                          this.boobleModalData?.receiver?.bankName
                      }}</span></span
                    ><br /><br />
                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount
                          ?.number || this.boobleModalData?.receiver?.account
                      "
                    >
                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.receiverAccount
                            ?.number || this.boobleModalData?.receiver?.account
                        "
                      >
                        <span class="p-text-grey"
                          >Conta: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.number ||
                              this.boobleModalData?.receiver?.account
                          }}</span></span
                        ><br /><br />
                      </ng-container>
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount
                          ?.institutionNumber
                      "
                    >
                      <span class="p-text-grey"
                        >Institution Number: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount
                            ?.institutionNumber
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.transit
                      "
                    >
                      <span class="p-text-grey"
                        >Transit: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount
                            ?.transit
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.address
                      "
                    >
                      <span class="p-text-grey"
                        >Address: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount
                            ?.address
                        }}</span></span
                      ><br /><br />
                    </ng-container>
                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.cbu
                      "
                    >
                      <span class="p-text-grey"
                        >CBU: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.cbu
                        }}</span></span
                      ><br /><br />
                    </ng-container>
                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount
                          ?.sortCode
                      "
                    >
                      <span class="p-text-grey"
                        >Sort Code: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount
                            ?.sortCode
                        }}</span></span
                      ><br /><br />
                    </ng-container>
                  </div>

                  <div class="col-md-6">
                    <span class="p-text-grey">
                      País:&nbsp;
                      <span class="value"
                        >{{
                          this.boobleModalData?.receiver?.country?.description
                        }}
                      </span></span
                    ><br /><br />
                    <span class="p-text-grey"
                      >Código SWIFT: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount
                          ?.swift || this.boobleModalData?.receiver?.swift
                      }}</span></span
                    ><br /><br />
                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.aba
                      "
                    >
                      <span class="p-text-grey"
                        >ABA: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.aba
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.iban
                      "
                    >
                      <span class="p-text-grey"
                        >IBAN: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.iban
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.cable
                      "
                    >
                      <span class="p-text-grey"
                        >Cable: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.cable
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.blz
                      "
                    >
                      <span class="p-text-grey"
                        >BLZ: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.blz
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.fcc
                      "
                    >
                      <span class="p-text-grey"
                        >FFC: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.fcc
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.cuit
                      "
                    >
                      <span class="p-text-grey"
                        >CUIT: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.cuit
                        }}</span></span
                      ><br /><br />
                    </ng-container>

                    <ng-container
                      *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.bsb
                      "
                    >
                      <span class="p-text-grey"
                        >BSB: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.bsb
                        }}</span></span
                      ><br /><br />
                    </ng-container>
                  </div>
                </div>

                <ng-container
                  *ngIf="
                    this.boobleModalData?.receiver?.intermediaryAccount?.country
                      ?.description
                  "
                >
                  <h4 class="mg-bottom-32 mg-top-8 title-generic">
                    Dados do banco intermediário
                  </h4>
                  <div class="row">
                    <div class="col-md-6">
                      <span class="p-text-grey">
                        País:&nbsp;
                        <span class="value"
                          >{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.country?.description
                          }}
                        </span></span
                      ><br /><br />
                      <span class="p-text-grey"
                        >Banco: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.bank
                        }}</span></span
                      ><br /><br />
                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.number
                        "
                      >
                        <span class="p-text-grey"
                          >Conta: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.number
                          }}</span></span
                        ><br /><br />
                      </ng-container>
                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.institutionNumber
                        "
                      >
                        <span class="p-text-grey"
                          >Institution Number: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.institutionNumber
                          }}</span></span
                        ><br /><br />
                      </ng-container>

                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.transit
                        "
                      >
                        <span class="p-text-grey"
                          >Transit: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.transit
                          }}</span></span
                        ><br /><br />
                      </ng-container>

                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.address
                        "
                      >
                        <span class="p-text-grey"
                          >Address: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.address
                          }}</span></span
                        ><br /><br />
                      </ng-container>

                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.cbu
                        "
                      >
                        <span class="p-text-grey"
                          >CBU: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.cbu
                          }}</span></span
                        ><br /><br />
                      </ng-container>

                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.sortCode
                        "
                      >
                        <span class="p-text-grey"
                          >Sort Code: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.sortCode
                          }}</span></span
                        ><br /><br />
                      </ng-container>
                    </div>
                    <div class="col-md-6">
                      <ng-container>
                        <span class="p-text-grey"
                          >Cidade: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.city
                          }}</span></span
                        ><br /><br />
                      </ng-container>
                      <span class="p-text-grey">
                        Código SWIFT: &nbsp;
                        <span class="value"
                          >{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.swift
                          }}
                        </span></span
                      ><br /><br />

                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.aba
                        "
                      >
                        <span class="p-text-grey"
                          >ABA: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.aba
                          }}</span></span
                        ><br /><br />
                      </ng-container>

                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.iban
                        "
                      >
                        <span class="p-text-grey"
                          >IBAN: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.iban
                          }}</span></span
                        ><br /><br />
                      </ng-container>

                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.cable
                        "
                      >
                        <span class="p-text-grey"
                          >Cable: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.cable
                          }}</span></span
                        ><br /><br />
                      </ng-container>
                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.blz
                        "
                      >
                        <span class="p-text-grey"
                          >BLZ: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.blz
                          }}</span></span
                        ><br /><br />
                      </ng-container>
                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.cuit
                        "
                      >
                        <span class="p-text-grey"
                          >CUIT: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.cuit
                          }}</span></span
                        ><br /><br />
                      </ng-container>
                      <ng-container
                        *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.bsb
                        "
                      >
                        <span class="p-text-grey"
                          >BSB: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                              ?.bsb
                          }}</span></span
                        ><br /><br />
                      </ng-container>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="this.boobleModalData?.quotations[0]">
                  <h4 class="mg-bottom-32 mg-top-8">
                    Dados do fechamento de câmbio
                  </h4>
                  <div class="row">
                    <div class="col-md-6">
                      <span class="p-text-grey">
                        Câmbio com spread:&nbsp;
                        <span class="value"
                          >R${{
                            commercial?.toString().replace(".", ",")
                          }}</span
                        ></span
                      ><br /><br />
                      <span class="p-text-grey"
                        >Tarifa: &nbsp;
                        <span class="value">
                          {{
                            this.boobleModalData?.quotations[0]?.tariff | brl
                          }}
                        </span></span
                      ><br /><br />
                      <span class="p-text-grey"
                        >Valor em reais: &nbsp;
                        <span class="value">
                          {{
                            this.boobleModalData?.quotations[0]?.amountMN | brl
                          }}
                        </span></span
                      ><br /><br />
                    </div>
                    <div class="col-md-6">
                      <ng-container *ngIf="boobleModalData?.quotations[0]?.id">
                        <span class="p-text-grey">
                          Câmbio comercial:&nbsp;
                          <span class="value"
                            >R${{
                              this.boobleModalData?.quotations[0]?.rate
                                ?.toString()
                                .replace(".", ",")
                            }}</span
                          ></span
                        ><br /><br />
                        <span class="p-text-grey"
                          >IOF ({{ iof * 100 | number : "1.2-2" }}%): &nbsp;
                          <span class="value"
                            >{{
                              commercial * this.boobleModalData?.amount * iof
                                | brl
                            }}
                          </span></span
                        ><br /><br />
                        <span class="p-text-grey">
                          Imposto de renda ({{ ir * 100 | number : "1.2-2" }}%):
                          &nbsp;
                          <span class="value">{{
                            getIr(
                              this.boobleModalData?.quotations[0]?.rate,
                              this.boobleModalData?.quotations[0]?.spread,
                              ir,
                              this.boobleModalData?.quotations[0]?.ptax
                            ) | brl
                          }}</span></span
                        ><br /><br />
                        <span class="p-text-grey">
                          Valor efetivo total: &nbsp;
                          <span class="value"
                            >{{
                              1
                                | currency
                                  : this.boobleModalData?.currency?.description
                            }}
                            =
                            {{
                              this.boobleModalData?.quotations[0]?.vet | brl
                            }}</span
                          ></span
                        ><br /><br />
                      </ng-container>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="this.boobleModalData?.reprovedMsg">
                  <h4>Motivo da reprovação</h4>
                  <div class="row">
                    <div class="reason">
                      <span>
                        {{ this.boobleModalData?.reprovedMsg }}
                      </span>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="this.boobleModalData?.canceledMsg">
                  <h4>Motivo do cancelamento</h4>
                  <div class="row">
                    <div class="reason">
                      <span>
                        {{ this.boobleModalData?.canceledMsg }}
                      </span>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>

        <ng-container
          *ngIf="
            this.boobleModalData?.statusFlow == 'IDENTIFYING_PAYMENT_ABROAD'
          "
        >
          <div class="buttons-end">
            <button
              class="btn mb-3"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              (click)="
                openBankChannelModal(
                  this.boobleModalData?.currency?.description
                )
              "
              type="button"
            >
              Consultar canal bancário
            </button>
          </div>
        </ng-container>

        <ng-container
          *ngIf="
            this.boobleModalData?.statusFlow == 'IDENTIFIED_PAYMENT_ABROAD'
          "
        >
          <div class="buttons-end">
            <button
              class="btn mb-3"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              (click)="openUpdateOrderModal(this.boobleModalData)"
              type="button"
            >
              Completar informações
            </button>
          </div>
        </ng-container>

        <ng-container
          *ngIf="this.boobleModalData?.statusFlow == 'AVAILABLE_QUOTATION'"
        >
          <div class="buttons-end">
            <button
              class="btn mb-3"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              (click)="openQuotationModal(this.boobleModalData)"
              type="button"
            >
              Cotar
            </button>
          </div>
        </ng-container>

        <ng-container
          *ngIf="
            this.boobleModalData?.statusFlow == 'PAID' &&
            (this.boobleModalData?.orderSettlement?.exchangeContractFile ||
              (boobleModalData?.orderSettlement?.proofOperationFile &&
            boobleModalData?.orderSettlement?.proofOperationFileApproved))
          "
        >
          <div class="buttons-end btns-darks">
            <button
              *ngIf="
                this.boobleModalData?.statusFlow == 'PAID' &&
                this.boobleModalData?.orderSettlement?.exchangeContractFile
              "
              class="btn mb-3 btn-grey-file"
              type="button"
              (click)="
                downloadAttachment(
                  this.boobleModalData?.orderSettlement?.exchangeContractFile
                )
              "
            >
              <div>
                <img src="assets/image/clip-icon.svg" />

                Contrato de câmbio
              </div>

              <div>
                <img src="assets/image/download-icon.svg" />
              </div>
            </button>

            <button
              *ngIf="
                this.boobleModalData?.statusFlow == 'PAID' &&
                boobleModalData?.orderSettlement?.proofOperationFile &&
            boobleModalData?.orderSettlement?.proofOperationFileApproved
              "
              class="btn mb-3 btn-grey-file"
              type="button"
              (click)="
                downloadAttachment(
                  this.boobleModalData?.orderSettlement?.proofOperationFile
                )
              "
            >
              <div>
                <img src="assets/image/clip-icon.svg" />

                Comprovantes
              </div>

              <div>
                <img src="assets/image/download-icon.svg" />
              </div>
            </button>
          </div>
        </ng-container>

        <ng-container
          *ngIf="
            this.boobleModalData?.statusFlow == 'AVAILABLE_PAYMENT' &&
            this.boobleModalData?.remmitanceType == 'OUTBOUND' &&
            this.boobleModalData?.quotations[0]
          "
        >
          <div class="buttons">
            <div class="loading-modal">
              <span
                class="align-self-center spinner-border spinner-border-sm"
              ></span>
              <span class="p-text-grey">Pagamento expira em </span>
              <span class="value-countdown">
                <countdown
                  [config]="{
                    leftTime: calcCountdown(
                      this.boobleModalData?.quotations[0]?.dueDate
                    )
                  }"
                  (event)="onCountdownFinished($event)"
                >
                </countdown>
              </span>
            </div>

            <button
              class="btn"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              (click)="openOrderPaymentModal(this.boobleModalData)"
              type="button"
            >
              Realizar o pagamento
            </button>
          </div>
        </ng-container>

        <ng-container
          *ngIf="this.boobleModalData?.statusFlow == 'REPROVED_WITH_CORRECTION'"
        >
          <div class="buttons-end">
            <button
              class="btn"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              (click)="openSendDocumentsModal(this.boobleModalData)"
              type="button"
            >
              Corrigir para nova análise
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
